import React from 'react'
const AuthLanding = ({ bg, className }) => {
  return (
    // <div className="hidden lg:flex  justify-center items-center bg-[url('../../assets/images/bg-portal.png')] bg-center  bg-cover bg-no-repeat w-full lg:w-[50%] h-[100vh]"></div>
    <div
      className={`md:flex hidden justify-start items-end pl-[58px] pr-[24px] pb-[44px] w-[50%] h-auto login-banner-bg ${
        bg ? "bg-[url('../../assets/images/login-img.png')]" : className
      }`}
    >
      <div>{/* <img src={CompanyLogo} alt="Company logo" /> */}</div>
      <div className="max-w-[427px]">
        <h2 className="text-2xl font-semibold text-[#E9DFFF] mb-[9px]">
          Hematogenix's mission
        </h2>
        <p className="max-w-[380px] w-full font-normal text-sm text-[#E9DFFF] m-0">
          Our mission is to assist pharma companies bring novel treatments from
          bench to bedside.
        </p>
      </div>
    </div>
  )
}

export default AuthLanding
